"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLiveRefresh = void 0;
var react_1 = require("react");
var core_1 = require("stremio/core");
var constants_1 = require("./constants");
var useEpgNow_1 = require("./useEpgNow");
var useLiveRefresh = function (model, field, enabled, intervalMs) {
    if (intervalMs === void 0) { intervalMs = constants_1.EPG_NOW_REFRESH_INTERVAL; }
    var core = (0, core_1.useCore)();
    var now = (0, useEpgNow_1.useEpgNow)(enabled, intervalMs);
    (0, react_1.useEffect)(function () {
        if (enabled) {
            core.transport.dispatch({ action: model, args: { action: 'RefreshLive' } }, field);
        }
    }, [enabled, now, model, field, core.transport]);
    return now;
};
exports.useLiveRefresh = useLiveRefresh;
